var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { HOOK_PLUGIN_SETTINGS_SET } from './const.js';
import { now } from './time.js';
var ApiProxy = /** @class */ (function () {
    function ApiProxy(plugin, hook) {
        var _this = this;
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        var defaultSettings = {};
        if (plugin.settings) {
            for (var id in plugin.settings) {
                var item = plugin.settings[id];
                defaultSettings[id] = item.defaultValue;
            }
        }
        var localSettingsSaveId = "__vue-devtools-plugin-settings__".concat(plugin.id);
        var currentSettings = Object.assign({}, defaultSettings);
        try {
            var raw = localStorage.getItem(localSettingsSaveId);
            var data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        }
        catch (e) {
            // noop
        }
        this.fallbacks = {
            getSettings: function () {
                return currentSettings;
            },
            setSettings: function (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                }
                catch (e) {
                    // noop
                }
                currentSettings = value;
            },
            now: function () {
                return now();
            },
        };
        if (hook) {
            hook.on(HOOK_PLUGIN_SETTINGS_SET, function (pluginId, value) {
                if (pluginId === _this.plugin.id) {
                    _this.fallbacks.setSettings(value);
                }
            });
        }
        this.proxiedOn = new Proxy({}, {
            get: function (_target, prop) {
                if (_this.target) {
                    return _this.target.on[prop];
                }
                else {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        _this.onQueue.push({
                            method: prop,
                            args: args,
                        });
                    };
                }
            },
        });
        this.proxiedTarget = new Proxy({}, {
            get: function (_target, prop) {
                if (_this.target) {
                    return _this.target[prop];
                }
                else if (prop === 'on') {
                    return _this.proxiedOn;
                }
                else if (Object.keys(_this.fallbacks).includes(prop)) {
                    return function () {
                        var _a;
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        _this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: function () { },
                        });
                        return (_a = _this.fallbacks)[prop].apply(_a, __spreadArray([], __read(args), false));
                    };
                }
                else {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        return new Promise(function (resolve) {
                            _this.targetQueue.push({
                                method: prop,
                                args: args,
                                resolve: resolve,
                            });
                        });
                    };
                }
            },
        });
    }
    ApiProxy.prototype.setRealTarget = function (target) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, item, _c, _d, item, _e, _f, e_1_1;
            var e_2, _g, _h, e_1, _j, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        this.target = target;
                        try {
                            for (_a = __values(this.onQueue), _b = _a.next(); !_b.done; _b = _a.next()) {
                                item = _b.value;
                                (_h = this.target.on)[item.method].apply(_h, __spreadArray([], __read(item.args), false));
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_g = _a.return)) _g.call(_a);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        _l.label = 1;
                    case 1:
                        _l.trys.push([1, 6, 7, 8]);
                        _c = __values(this.targetQueue), _d = _c.next();
                        _l.label = 2;
                    case 2:
                        if (!!_d.done) return [3 /*break*/, 5];
                        item = _d.value;
                        _f = (_e = item).resolve;
                        return [4 /*yield*/, (_k = this.target)[item.method].apply(_k, __spreadArray([], __read(item.args), false))];
                    case 3:
                        _f.apply(_e, [_l.sent()]);
                        _l.label = 4;
                    case 4:
                        _d = _c.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _l.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_d && !_d.done && (_j = _c.return)) _j.call(_c);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    return ApiProxy;
}());
export { ApiProxy };
